import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider } from '@mui/material/styles';


// Digital twin widgets
import TotalAlerts from '../components/TotalAlerts';
import Chart from '../components/charts/Chart';
import Stations from '../components/Stations';
import GridMap from '../components/GridMap';
import DateBar from '../components/DateBar';
import Status from '../components/Status';
import WeatherWidget from '../components/WeatherWidget';

const mdTheme = createTheme();


class DashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  handleChange = name => event => {
    //if (name == "question1") 
    //event.target.value
  }

  render() {
    return (     
      <ThemeProvider theme={mdTheme}>
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
          <Grid container spacing={3}>
            {/* Date Bar */}
            <Grid item xs={12} md={12} lg={12}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 140,
                }}
              >
                <DateBar />
              </Paper>
            </Grid>
            {/* Map Components*/}
            <Grid item xs={6}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 420 }}>
                <GridMap />
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 420 }}>
                <Stations />
              </Paper>
            </Grid>
          </Grid>
          </Container>
          <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
          {/* Info Widgets */}
          <Grid container spacing={3}>
            <Grid item xs={6} md={4} lg={4}>

              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 300,
                }}
              >
                <Chart />
              </Paper>
            </Grid>
            <Grid item xs={6} md={4} lg={4}>

              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 300,
                }}
              >
                <Status 
                  backColor= "#13a15c"
                  backColorHover="#1ed47b"
                  title="Status"
                  status= "Normal"
                  date='Feb 28, 2022 T12:06PM'
                />
              </Paper>
            </Grid>

            <Grid item xs={12} md={4} lg={4}>
              <Paper
                sx={{
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 300,
                }}
              >
                <TotalAlerts />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </ThemeProvider>

    )
  }
}

export default DashboardView;